import React, { useState, useEffect, useCallback } from "react";
import { getLeaveBalance } from "../../../services/attendanceApi";
import Icons from "./Icons";

/**
 * LeaveBalance — shows remaining balance per leave type (CL/SL/EL).
 * Unpaid leave (LOP) has no balance and is not shown here.
 */
const TYPE_LABELS = { CL: "Casual", SL: "Sick", EL: "Earned", COMP_OFF: "Comp-Off" };

function LeaveBalance({ refreshKey }) {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const res = await getLeaveBalance();
      const data = res && res.data ? res.data : res;
      setBalances(Array.isArray(data) ? data : (data.balances || []));
    } catch (err) {
      setError(err.message || "Could not load leave balance.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  if (loading) {
    return <div className="atl-card atl-balance"><div className="atl-skeleton" /></div>;
  }

  return (
    <div className="atl-card atl-balance">
      <h3><span className="atl-h3ic">{Icons.balance}</span>Leave Balance</h3>
      {error && <div className="atl-error">{error}</div>}
      {balances.length === 0 ? (
        <div className="atl-empty">No leave balance allocated yet.</div>
      ) : (
        <div className="atl-balance__grid">
          {balances.map((b) => {
            const type = b.leaveType || b.leave_type;
            const allocated = Number(b.allocated || 0);
            const remaining = Number(b.remaining ?? (allocated - (b.used || 0)));
            const used = Number(b.used || 0);
            const pct = allocated > 0 ? Math.round((remaining / allocated) * 100) : 0;
            return (
              <div key={type} className="atl-balance__card">
                <div className="atl-balance__type">{TYPE_LABELS[type] || type}</div>
                <div className="atl-balance__num">{remaining}<span> / {allocated}</span></div>
                <div className="atl-balance__bar">
                  <div className="atl-balance__fill" style={{ width: `${pct}%` }} />
                </div>
                <div className="atl-balance__used">{used} used</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default LeaveBalance;
